export default __webpack_public_path__ + "static/media/2016.dd094038.png";